import React, { useState, useEffect } from "react";
import "../index.css";
import { useAuth } from "../AuthProvider";
import logo from "../imgs/logo_login.svg";

const wrapperStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "100vh",
  backgroundColor: "#ffffff",
};

const cardStyle = {
  width: "100%",
  maxWidth: "750px",
  padding: "60px 210px",
  borderRadius: "24px",
  border: "1px solid #f1f5f9",
  boxShadow: "0 10px 40px rgba(0, 0, 0, 0.04)",
  backgroundColor: "#ffffff",
  textAlign: "center",
  boxSizing: "border-box",
};

const logoContainerStyle = {
  marginBottom: "40px",
};

const inputGroupStyle = {
  marginBottom: "24px",
  textAlign: "left",
};

const labelStyle = {
  display: "block",
  fontSize: "13px",
  fontWeight: "500",
  color: "#475569",
  marginBottom: "8px",
  fontFamily: "Pretendard, sans-serif",
};

const inputStyle = {
  width: "100%",
  padding: "16px 16px",
  fontSize: "15px",
  border: "1px solid #e2e8f0",
  borderRadius: "10px",
  backgroundColor: "#f8fafc",
  boxSizing: "border-box",
  outline: "none",
  fontFamily: "Pretendard, sans-serif",
  color: "#0f172a",
  transition: "border-color 0.2s",
};

const checkContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  marginBottom: "40px",
  gap: "8px",
};

const checkLabelStyle = {
  fontSize: "13px",
  fontWeight: "500",
  color: "#374151",
  fontFamily: "Pretendard, sans-serif",
  cursor: "pointer",
  userSelect: "none",
};
 
const loginBtnStyle = {
  width: "100%",
  padding: "16px",
  backgroundColor: "#3b82f6",
  color: "#ffffff",
  border: "none",
  borderRadius: "10px",
  fontSize: "16px",
  fontWeight: "700",
  cursor: "pointer",
  fontFamily: "Pretendard, sans-serif",
  transition: "background-color 0.2s, transform 0.1s",
};

const Login = () => {
  const [id, setId] = useState("");
  const [pwd, setPwd] = useState("");
  const [checked, setChecked] = useState(false);
  const [focusedInput, setFocusedInput] = useState(null);
  const auth = useAuth();

  const handleLogin = (e) => {
    e.preventDefault();
    auth.loginAction(id, pwd, checked);
  };

  const handleIdChanged = (e) => {
    setId(e.target.value);
  };

  const handlePwdChanged = (e) => {
    setPwd(e.target.value);
  };

  const handleCheckChange = () => {
    setChecked(!checked);
  };

  useEffect(() => {
    const savedId = localStorage.getItem("id");
    const savedChecked = localStorage.getItem("checked") === "true";

    if (savedId) setId(savedId);
    setChecked(savedChecked);
  }, []);
  const getCheckboxStyle = (isChecked) => ({
    appearance: "none",
    WebkitAppearance: "none",
    width: "20px",
    height: "20px",
    backgroundColor: isChecked ? "#3b82f6" : "#F3F4F6",
    border: `1px solid ${isChecked ? "#3b82f6" : "#E5E7EB"}`,
    borderRadius: "6px",
    cursor: "pointer",
    margin: "0",

    backgroundImage: isChecked
      ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3E%3Cpath d='M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z'/%3E%3C/svg%3E")`
      : "none",
    backgroundSize: "14px",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    transition: "all 0.2s ease-in-out",
  });
  const getInputStyle = (isFocused) => ({
    width: "100%",
    padding: "16px 16px",
    fontSize: "15px",
    border: `1px solid ${isFocused ? "#2C6AFF" : "#E5E7EB"}`,
    borderRadius: "10px",
    backgroundColor: isFocused ? "#EFF3FD" : "#F3F4F6",
    boxSizing: "border-box",
    outline: "none",
    fontFamily: "Pretendard, sans-serif",
    color: "#0f172a",
    transition: "all 0.2s ease-in-out",
  });
  return (
    <div style={wrapperStyle}>
      <div style={cardStyle}>
        <form onSubmit={handleLogin}>
          <div style={logoContainerStyle}>
            <img
              src={logo}
              style={{ height: "130px", width: "auto", objectFit: "contain" }}
              alt="NeuroCare Logo"
            />
          </div>

          <div style={inputGroupStyle}>
            <label style={labelStyle}>아이디</label>
            <input
              style={getInputStyle(focusedInput === "id")}
              type="text"
              value={id}
              onChange={handleIdChanged}
              onFocus={() => setFocusedInput("id")}
              onBlur={() => setFocusedInput(null)}
            />
          </div>

          <div style={inputGroupStyle}>
            <label style={labelStyle}>비밀번호</label>
            <input
              style={getInputStyle(focusedInput === "pwd")}
              type="password"
              value={pwd}
              onChange={handlePwdChanged}
              onFocus={() => setFocusedInput("pwd")}
              onBlur={() => setFocusedInput(null)}
            />
          </div>

          <div style={checkContainerStyle}>
            <input
              type="checkbox"
              id="keepLogin"
              checked={checked}
              onChange={handleCheckChange}
              style={getCheckboxStyle(checked)}
            />
            <label htmlFor="keepLogin" style={checkLabelStyle}>
              로그인 상태 유지
            </label>
          </div>

          <button type="submit" style={loginBtnStyle}>
            로그인
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
